import type { Breadcrumb } from '@sentry/react';

export const formatJsSipBreadcrumb = (breadcrumb: Breadcrumb): Breadcrumb => {
  if (breadcrumb.message) {
    breadcrumb.message = breadcrumb.message
      .replaceAll('%c', '')
      .replaceAll(/\+\d+ms/g, '')
      .replaceAll(/color: #[a-z0-9]{3,6}/gi, '')
      .replaceAll('color: inherit', '');
  }

  return breadcrumb;
};
